export const mainNum = 9

export const SHELF_TEMPLATE = 'shelfTemplate' // 铺货模板内的发货模式
export const SHELF_SHOP = 'shelfShop' // 单个上架的发货模式

export const DELIVERY_TIME_LABEL = '发货时效'
export const DELIVERY_TIME_REAL_NAME = 'deliveryTime'
